/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { CdsServizio } from "./CdsServizio";
import * as t from "io-ts";

// required attributes
const CdsServizioListR = t.interface({
  services: t.readonlyArray(CdsServizio, "array of CdsServizio")
});

// optional attributes
const CdsServizioListO = t.partial({});

export const CdsServizioList = t.intersection(
  [CdsServizioListR, CdsServizioListO],
  "CdsServizioList"
);

export type CdsServizioList = t.TypeOf<typeof CdsServizioList>;
